import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Table from '@/modules/common/components/Table';
import RegExpField from '@/modules/common/components/RegExpField';
import DateRangeField from '@/modules/common/components/DateRangeField';
import TableContainer from '@/modules/common/components/TableContainer';
import { formatDateTime } from '~/common';

const Component = (props) => {
    const getLevel = (levelno) => {
        switch (levelno) {
            case 10:
                return 'debug';
            case 20:
                return 'info';
            case 30:
                return 'warning';
            case 40:
                return 'error';
            default:
                return 'info';
        }
    };

    const getDateTime = (created) => {
        return formatDateTime(created, 'dd.MM.yy HH:mm:ss');
    };

    const handleChange = (prop) => (event) => {
        props.setValuesFilter({...props.valuesFilter, [prop]: event.target.value});
    };

    // noinspection JSValidateTypes
    return (
        <TableContainer responsive={true}>
            <Table>
                <TableHead>
                    <TableRow id="row-head">
                        <TableCell className="level"/>
                        <TableCell className="datetime">Дата/Время</TableCell>
                        <TableCell className="name">Название</TableCell>
                        <TableCell>Сообщение</TableCell>
                    </TableRow>
                    <TableRow className="table-row-filter">
                        <TableCell className="level"/>
                        <TableCell className="datetime">
                            <DateRangeField value={props.valuesFilter.created}
                                            setValue={(value) => props.setValuesFilter({
                                                ...props.valuesFilter,
                                                created: value,
                                            })}
                            />
                        </TableCell>
                        <TableCell className="name">
                            <RegExpField value={props.valuesFilter.name} onChange={handleChange('name')}
                                         inputProps={{form: 'form-filter'}}
                            />
                        </TableCell>
                        <TableCell>
                            <RegExpField value={props.valuesFilter.msg} onChange={handleChange('msg')}
                                         inputProps={{form: 'form-filter'}}
                            />
                        </TableCell>
                    </TableRow>
                </TableHead>
                {(props.journal.length > 0)
                    ? <TableBody>
                        {props.journal.map((log, id) => (
                            <TableRow key={id}>
                                <TableCell className={`level level-${getLevel(log.levelno)}`}><div/></TableCell>
                                <TableCell className="datetime">{getDateTime(new Date(log.created))}</TableCell>
                                <TableCell className="name">{log.name}</TableCell>
                                <TableCell>{log.msg}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    : null
                }
            </Table>
        </TableContainer>
    );
};

Component.propTypes = {
    valuesFilter: PropTypes.object.isRequired,
    setValuesFilter: PropTypes.func.isRequired,
    journal: PropTypes.array.isRequired,
};

export default Component;
